module.exports = __webpack_public_path__ + "img/nyk_giftcard.9f2aa393.jpg";